import React from 'react'
import type { Icon } from 'shared/utils'

const CircleColdDrink = (props: Icon) => {
    const {
        color = 'black',
        background = 'white',
        size = 24,
        className = 'circle-cold-drink'
    } = props
    return (
        <svg width={size} height={size} className={className}>
            <g fill="none" fillRule="evenodd">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={size / 2}
                    fill={background}
                />
                <path
                    fill={color}
                    d="M23.152 11.685h-3.557l.63-6.752 2.567-1.17a.556.556 0 00.27-.766.556.556 0 00-.766-.27l-2.88 1.306c-.18.045-.315.27-.315.45l-.675 7.201H9.919a.596.596 0 00-.586.586c0 .315.27.585.586.585h.54l1.575 15.843c.045.315.27.54.585.54h8.058c.314 0 .54-.224.584-.54l1.576-15.844h.315c.314 0 .584-.27.584-.584a.596.596 0 00-.585-.585"
                />
            </g>
        </svg>
    )
}

export { CircleColdDrink }
